import classNames from "classnames";
import { SidePanelType, useSidePanelActions } from "PFApp/stores/side_panels_store";
import { Activity, ActivityPreview, ProfileMinimized } from "PFTypes";
import { PropsWithChildren } from "react";

import css from "./activity_preview_link.module.scss";

type ActivityPreviewLinkProps = PropsWithChildren & {
  activity: Activity;
  profile: ProfileMinimized;
  className?: string;
};

const ActivityPreviewLink = ({ activity, profile, className, children }: ActivityPreviewLinkProps) => {
  const { open } = useSidePanelActions<ActivityPreview>(SidePanelType.ActivityPreview);

  return (
    <button
      className={classNames(css.previewLink, className)}
      onClick={() => {
        open({ id: activity.id, profile });
      }}
    >
      {children || activity.name}
    </button>
  );
};

export default ActivityPreviewLink;
